import { cn } from '../../utils/cn';

/**
 * Classes that draw a flagged row's outline on its cells instead of the row.
 *
 * A host colors a row through `getRowClassName`, and the shared badge classes
 * it uses carry a border (`border border-warning-tint`). The shared Table is
 * border-collapse, and Chrome paints collapsed borders above a sticky header,
 * so a flagged row scrolled under the header showed its side borders running
 * up through the header (seen on the client cart, PD-16861). Here the row
 * keeps its border color but loses the width; each cell inherits the color and
 * draws the row's sides with a `::before`, which sits in the cells' own layer
 * and is covered by the sticky header like any background. Returns '' for a
 * row without a border.
 */
export function rowOutlineClasses(
	rowClassName: string,
	sides: { top: boolean; bottom: boolean },
): string {
	if (!/(^|\s)border(\s|$)/.test(rowClassName)) {
		return '';
	}
	return cn(
		'border-0',
		'[&>td]:[border-color:inherit] [&>td:not(.sticky)]:relative',
		"[&>td]:before:pointer-events-none [&>td]:before:absolute [&>td]:before:inset-0 [&>td]:before:content-[''] [&>td]:before:[border-color:inherit]",
		'[&>td:first-child]:before:border-l [&>td:last-child]:before:border-r',
		sides.top && '[&>td]:before:border-t',
		sides.bottom && '[&>td]:before:border-b',
	);
}
